import React from 'react';

function Contact() {
    return <p>contact</p>;
}

export default Contact;